import useBlProviders from '@/composables/providers/useBlProvider'
import InfrastructureTypesDt from '@/services/dataTransferModules/infrastructureTypesDt'

const infrastructureTypesDt = new InfrastructureTypesDt()

export default function useInfrastructureTypes() {
	const {
		loadEntityFlags: flags,

		entities: fullInfrastructureTypes,
		getEntities: getFulledInfrastructureTypes,

		basedEntities: baseInfrastructureTypes,
		getBasedEntities: getBasedInfrastructureTypes,

		extendedEntities: extendedInfrastructureTypes,
		getExtendedEntities: getExtendedInfrastructureTypes,

		entity: infrastructureType,
		getEntity: getInfrastructureType,

		entityPreview: infrastructureTypePreview,
		getEntityPreview: getInfrastructureTypesPreview,

		createEntity: createInfrastructureTypes,
		patchEntity: updateInfrastructureTypes,
		updateEntity: fullUpdateInfrastructureTypes,
		deleteEntity: deleteInfrastructureTypes,
	} = useBlProviders(infrastructureTypesDt, {
		showErrorNotificationForLoadingAllEntities: true,
		showErrorNotificationForLoadingOneEntity: true,
		showErrorNotificationForCreatingEntity: true,
		showErrorNotificationForUpdatingEntity: true,
		showErrorNotificationForDeletingEntity: true,
	})

	const defaults = {
		creatingInfrastructureType: {
			name: '',
			color: '',
		},
		fieldsToPatch: ['name', 'color'],
	}

	return {
		flags,
		fullInfrastructureTypes,
		baseInfrastructureTypes,
		extendedInfrastructureTypes,
		infrastructureType,
		infrastructureTypePreview,
		defaults,

		getBasedInfrastructureTypes,
		getExtendedInfrastructureTypes,
		getFulledInfrastructureTypes,
		getInfrastructureType,
		getInfrastructureTypesPreview,
		createInfrastructureTypes,
		deleteInfrastructureTypes,
		updateInfrastructureTypes,
		fullUpdateInfrastructureTypes,
	}
}
